export const REG_EXP = {
  EMAIL:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[()*&^%$#@!_+])[A-Za-z\d()*&^%$#@!_+]{8,}$/, // at least eight characters with one lowercase letter, one uppercase letter, one number and one special character
  PHONE: /^\d{10}$/,
  NAME: /^[a-zA-Z ]{2,30}$/,
  ADDRESS: /^[a-zA-Z0-9\s,.'-]{2,50}$/,
  CITY: /^[a-zA-Z ]{2,30}$/,
  ONLY_NUMBER: /^\d+$/,
  ONLY_LETTER: /^[a-zA-Z]+$/,
  ONLY_LETTER_AND_NUMBER: /^[a-zA-Z0-9]+$/,
  ONLY_LETTER_AND_NUMBER_AND_SPACE: /^[a-zA-Z0-9 ]+$/,
  ONLY_LETTER_AND_NUMBER_AND_SPACE_AND_SPECIAL_CHARACTER:
    /^[a-zA-Z0-9 !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+$/,
  CONTAIN_SPECIAL_CHARACTER: /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/,
  CONTAIN_NUMBER: /\d/,
  CONTAIN_UPPERCASE: /[A-Z]/,
  CONTAIN_LOWERCASE: /[a-z]/,
  URL: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/,
  PHONE_AND_COUNTRY_CODE: /^\+[1-9]{1}[0-9]{3,14}$/,
  ONLY_NUMBER_AND_DECIMAL: /^\d+(\.\d{1,3})?$/,
  TIME_REGEX: /^(0?[1-9]|1[0-2]):[0-5][0-9](am|pm|AM|PM)$/,
  FULL_NAME: /^[A-Za-z]+(?:[ -][A-Za-z]+)*$/,
};
